import '@babel/polyfill';
import $ from 'jquery';
// import Flickity from 'flickity';
import 'focus-visible';
import 'nodelist-foreach-polyfill';

import DDTemplates from './DDTemplates';
import Drupal from './Drupal';
import Header from './Header';
import Toolbar from './Toolbar';
import Viewport from './Viewport';
import Sticky from './Sticky';
import Gallery from './Gallery';
import Navigation from './Navigation';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import AccordionWrap from './AccordionWrap';
import AccordionFix from './AccordionFix';
import AccordionContainer from './AccordionContainer';
import SearchRelocate from './SearchRelocate';
// import HeaderlinksRelocate from './HeaderlinksRelocate';
import Modaal from './Modaal';
import SelectBox from './SelectBox';
import SelectList from './SelectList';
import BackgroundImage from './BackgroundImage';
import FlickityHomePod from './Flickity.HomePod';
// import Notify from './Notify';
import Redirect from './Redirect';
import BrowserCheck from './BrowserCheck';

const ESC_KEY = 27;

// Add the theme behaviors
Drupal.behavior((context) => {
  // Helpers
  const $body = $(document.body, context);

  // Get browser and version
  $body.each((i, element) => {
    if (!element.browserCheck) {
      element.browserCheck = new BrowserCheck(element);
    }
  });

  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates(context);
  }

  // Replace Lightbox lightframe functionality with Modaal.
  document.querySelectorAll('.open-lightframe').forEach((element) => {
    if (!element.Modaal) {
      const selector = '.node-header a, .field-image a, .link-read-more a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Replace Lightbox slideshow functionality with Modaal.
  document.querySelectorAll('.te-open-slideshow .node, .te-open-slideshow.node').forEach((element) => {
    if (!element.Modaal) {
      const selector = '.field-image a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Replace Lightbox and Lighframe straggelers.
  $('[rel^=lightbox], [rel^=lightframe]', context).closest('.node').each((i, element) => {
    if (!element.Modaal) {
      // const selector = '.node-header a, .field-image a, .link-read-more a';
      const selector = '.field-image a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.main-navigation, .term-navigation', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main Navigation
  $('.primary-navigation--desktop #nice-menu-3', context).each((i, element) => {
    if (!element.Navigation) {
      element.Navigation = new Navigation(element);
    }
  });
  $('.primary-navigation--mobile #nice-menu-3', context).each((i, element) => {
    if (!element.Navigation) {
      element.Navigation = new Navigation(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Relocate search based on media query
  $('.site-search', context).each((i, element) => {
    if (!element.searchRelocate) {
      element.searchRelocate = new SearchRelocate(element);
    }
  });

  // Relocate headerlinks based on media query
  // const headerlinks = document.querySelector('.headerlinks');
  // if (headerlinks && !headerlinks.headerlinksRelocate) {
  //   headerlinks.headerlinksRelocate = new HeaderlinksRelocate(headerlinks);
  // } else {
  document.querySelector('.page-header').classList.add('ready');
  // }

  // Controls the page overlay display
  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    if (!element.SmartFooter) {
      const $reactiveElement = $('.page', context);
      element.SmartFooter = new SmartFooter(element, $reactiveElement);
    }
  });

  // Term Navigation
  $('.term-navigation', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Wraps each accordion element
  $('.accordion-heading', context).each((i, element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
      element.accordionWrap = new AccordionFix(element);
    }
  });

  // Wraps each accordion in a container
  $('.node-content', context).each((i, element) => {
    if (!element.accordionContainer) {
      setTimeout(() => {
        element.accordionContainer = new AccordionContainer(element);
      }, 300);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });

  // Notifications
  $('.cc-bottom', context).each((i, element) => {
    if ($('.cc-bottom .block-inner').length < 1) {
      $(element).prepend('<div class="block-inner pt194"></div>');
      $('.cc-bottom .block-inner').prepend('<div class="block-content content"></div>');
      $('.cc-bottom .block-content').prepend('<div class="node node-teaser pt194"></div>');
      $('.cc-bottom .node').prepend('<div class="node-inner"></div>');
      const $node = $('.cc-bottom .node-inner');
      $node.prepend('<header class="node-header node-item"><h2 class="title"></h2></header>');
      $node.append('<div class="node-links node-item"><ul class="links inline"><li class="link link-read-more"></li></ul></div>');
      $('.cc-bottom .cc-message').appendTo('.cc-bottom .node-header .title');
      $('.cc-bottom .cc-message a').appendTo('.cc-bottom .node-links .link-read-more');
      $('.cc-bottom .cc-compliance').prependTo('.cc-bottom .block-content');
    }
  });

  // Background Images
  $('.hero .views-row', context).each((i, element) => {
    if (!element.bgImage) {
      element.bgImage = new BackgroundImage(element);
    }
  });

  $('.banner', context).each((i, element) => {
    if (!element.bannerBgImage) {
      element.bannerBgImage = new BackgroundImage(element, {
        sourceSelector: 'figure img',
        destSelector: '.node-banner',
      });
    }
  });

  $('.home-events .views-row, .home-news .views-row, .home-tiles .views-row, .home-help .views-row', context).each((i, element) => {
    if (!element.podBgImage) {
      element.podBgImage = new BackgroundImage(element, {
        destSelector: '.node-image',
      });
    }
  });

  // Make entire node clickable
  $('.home-about-us .views-row, .home-tiles .views-row, .home-adventure-icons .views-row', context).each((i, element) => {
    if (!element.redirect) {
      element.redirect = new Redirect(element, {
        linkLocation: '.node-header h2 a',
      });
    }
  });
  $('.home-events .views-row', context).each((i, element) => {
    if (!element.redirect) {
      element.redirect = new Redirect(element, {
        linkLocation: '.node-header h2 a',
        selector: '.node-teaser',
      });
    }
  });

  // Flickity Slider
  $('.home-news, .home-events, .hero', context).each((i, element) => {
    if (!element.homeSlider) {
      element.homeSlider = new FlickityHomePod(element);
    }
  });

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }

  // Select list generators
  let selectIdentifier = 1;
  $('.headerlinks', context).each((i, element) => {
    if (!element.headerlinksSelect) {
      element.headerlinksSelect = new SelectList(element, {
        destination: '.view',
        placeholder: 'I Want To',
        numerator: selectIdentifier,
        label: 'Quick Links',
      });
      selectIdentifier += 1;
      element.headerlinksSelect = new SelectBox(element, {
        selector: '.view',
        placeholder: 'I Want To',
        options: '.view-content',
        optionSrc: '.views-row .node-header',
        remove: true,
      });
      $(element).addClass('ready');
    }
    setTimeout(() => {
      $(element).addClass('ready');
    }, 500);
  });

  // Close flyout when Escape key is pressed.
  $(window).keydown((event) => {
    if (event.which === ESC_KEY) {
      $(document.body).removeClass('menu-active search-active');
    }
  });

  // Move headerlinks to grid box
  const headerlinks = document.querySelector('.headerlinks');
  const helpHeader = document.querySelector('.home-help header.node-header');

  // console.log(helpHeader);
  if (helpHeader) {
    helpHeader.insertAdjacentElement('afterend', headerlinks);
  } else {
    headerlinks.remove();
  }

  // Force Viewport Update
  Viewport.update();
});
